import { CSSObject, BoxProps } from '@chakra-ui/react';

export const DeductionsText: CSSObject = {
  color: 'gamma.400',
  fontSize: '2xs',
  fontWeight: 'semibold',
};
export const FooterMoreOpenText: CSSObject = {
  color: 'gamma.400',
  '&': {
    px: '0',
    borderBottom: '1px dashed',
    borderBottomColor: 'rgba(0, 0, 0, 0.4)',
  },
  fontSize: 'xs',
  '+ div[class*="myBetsCard-ContentRow"]': {
    position: 'relative',
    borderTop: 'none',
    '&::before': {
      position: 'absolute',
      content: '""',
      width: '100%',
      height: '0',
      top: '0',
      left: '0',
      borderBottom: '1px dashed',
      borderBottomColor: 'rgba(255, 255, 255, 0.08)',
    },
  },
};
export const BoxMoreText: CSSObject = {
  w: '8',
};
export const DividerMulti: CSSObject = {
  position: 'relative',
  border: 'none',
  width: 'unset',
  '&::before': {
    position: 'absolute',
    content: '""',
    width: '100%',
    height: '100%',
    top: '1px',
    left: '0',
    borderBottom: '1px dashed',
    borderBottomColor: 'rgba(0, 0, 0, 0.4)',
  },
};
export const footerWrapperExpanded: BoxProps = {
  sx: {
    borderTop: '1px dashed',
    borderTopColor: 'rgba(255, 255, 255, 0.08)',
    '& > div': {
      color: 'white',
    },
  },
};

export const toteMultiGrid: CSSObject = {
  gridTemplateColumns: 'repeat(2, 1fr)',
  gap: '6',
  display: 'grid',
};

export const toteMultiGridText: CSSObject = {
  fontSize: 'xs',
  w: 'full',
  color: 'white',
  mb: '2',
  '&.raceNumber': {
    borderBottom: '1px dashed',
    borderColor: '#00000040',
    boxShadow: '0px 1px 0px 0px #FFFFFF1A',
    fontWeight: 'bold',
  },
};
